// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FootballField_wrapper__2S86l","football-field":"FootballField_football-field__2eRj6","lines":"FootballField_lines__FbjvN"};